import { Navigate } from "react-router-dom";
import { useGlobalContext } from "../context/stateContext";
import Loading from "../components/Loading/Loading";

const PrivateRoutes = ({component: Component, ...rest}) => {
  const { isAuthenticated, authChecked } = useGlobalContext();

    if (!authChecked) {
      return <Loading />;
    }

    return isAuthenticated ?  <Component {...rest} /> : <Navigate to="/" />;
};

export default PrivateRoutes;
